import Dropdown, { dropdownTriggerClassname } from "app/components/Dropdown";
import { CheckIcon } from "app/components/Icons";
import Pill from "app/components/Pill";
import CustomTooltip from "app/components/Tooltip";
import { selectTicketStatus } from "app/redux/selector";
import { ITicketStatus } from "app/types";
import clsx from "clsx";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { getStatusById, getStatusesByTicketTypes } from "../../../../helpers";

interface Props {
  ticket: { _id: string; status: string; type: string };
  onUpdate: (id: string) => void;
}

const Status: React.FC<Props> = ({ ticket, onUpdate }) => {
  const { status, type } = ticket;

  const statusData = useSelector(selectTicketStatus);

  // FIX: visibleStatuses must be a state
  const [visibleStatuses, setVisibleStatuses] = useState<ITicketStatus[]>([]);

  const handleSelect = (data: ITicketStatus) => {
    // update form out side parent compoent
    onUpdate?.(data._id);
  };

  // FIX: Calculate visible statuses when ticket type or statusData changes
  useEffect(() => {
    const result = getStatusesByTicketTypes(statusData, type);
    setVisibleStatuses(result);
  }, [statusData, type]);

  // FIX: selectedStatus now works
  const selectedStatus = useMemo(() => {
    return getStatusById(statusData, status);
  }, [visibleStatuses, status]);

  // Dropdown menu items (should also use visibleStatuses)
  const MenuItems = statusData.map((option) => ({
    label: (
      <div className="flex items-center py-1 w-full">
        <span
          className="flex items-center justify-between text-white rounded-md w-full text-sm font-normal max-w-[168px] px-3 py-2"
          style={{ backgroundColor: option.color }}
        >
          <div className="w-full text-center">{option.name}</div>
          {option._id === status && (
            <div className="min-w-[20px] flex justify-end ml-2">
              <CheckIcon color="#fff" />
            </div>
          )}
        </span>
      </div>
    ),
    action: () => handleSelect(option),
    isUnPaddedY: true,
  }));

  return (
    <div className="">
      <Dropdown
        trigger={
          <button
            className={clsx(
              "flex items-center  hover:border !hover:border-gray-300 p-[4px] rounded-[2px] min-w-max cursor-pointer w-full h-full ",
              dropdownTriggerClassname,
            )}
          >
            <CustomTooltip text="Change status " position="bottom">
              <Pill
                className=" h-full w-[141px] text-sm leading-[21px] font-normal rounded !text-[#fff] "
                backgroundColor={selectedStatus?.color}
                name={selectedStatus?.name as string}
              />
            </CustomTooltip>
          </button>
        }
        menuItems={MenuItems}
        align="center"
        className=" max-w-[200px] py-2 "
        dropDownClassName=" max-w-[200px] "
        showTooltipArrowIcon

      />
    </div>
  );
};

export default Status;
